import http from 'common-module/src/util/http';

export const getSprintByProject = async (id) => {
  return http.post('/sprint/list-by-project-id', { id });
  //
};

export const getStatisticSprintByProject = async (id) => {
  return http.post('/issue-statistic/list-by-project-id', { id });
};
// 看板筛选条件自定义字段列表
export async function loadFilterField(data) {
  return http.post('/kanban/filter/field', data);
}
/**
 * 获取筛选字段选项
 * @param data
 * @returns {Promise<*>}
 */
export const getFilterFieldOption = async (data) => {
  return http.post('/account/filter-spaces/kanban/select-options', data);
};
